import FieldTypeReferenceDto from "../FieldTypeReferenceDto";
import FilterParameterDto from "../datasourcemodule/FilterParameterDto";
import DataTableFieldParameterDefinitionDto from "../datasourcemodule/DataTableFieldParameterDefinitionDto";

class SynchroFieldMappingDto {
    IsKey: boolean;
    SourceFieldReferenceId: number | null;
    TransformationType: number | null;
    TransformationParameters: string | null;
    TargetFieldReferenceId: number;
    Name: string;
    Type: FieldTypeReferenceDto;
    TypeLabel: string;
    ReadOnly: boolean;
    Filters: FilterParameterDto[];
    DeclaredVariables: DataTableFieldParameterDefinitionDto[];

    constructor(
        isKey: boolean,
        sourceFieldReferenceId: number | null,
        transformationType: number | null,
        transformationParameters: string | null,
        targetFieldReferenceId: number,
        name: string,
        type: FieldTypeReferenceDto,
        readOnly: boolean,
        filters: FilterParameterDto[],
        declaredVariables: DataTableFieldParameterDefinitionDto[] = []
    ) {
        this.IsKey = isKey;
        this.SourceFieldReferenceId = sourceFieldReferenceId;
        this.TransformationType = transformationType;
        this.TransformationParameters = transformationParameters;
        this.TargetFieldReferenceId = targetFieldReferenceId;
        this.Name = name;
        this.Type = type;
        this.TypeLabel = type.TypeLabel;
        this.ReadOnly = readOnly;
        this.Filters = filters;
        this.DeclaredVariables = declaredVariables;
    }
}

export default SynchroFieldMappingDto;
